"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcRentalFormProperties = exports.RentalProperty = void 0;
const RentalProperty_yaml_component_1 = __importDefault(require("./RentalProperty.yaml?component"));
exports.RentalProperty = RentalProperty_yaml_component_1.default;
const UcRentalFormProperties_yaml_component_1 = __importDefault(require("./UcRentalFormProperties.yaml?component"));
exports.UcRentalFormProperties = UcRentalFormProperties_yaml_component_1.default;
